import { SWEEP_ELEMENTS } from '../helpers';
import { ConfigurationType } from '../types';

export const aiPossibleTypes = [
  // changes should be consulted with BE
  ConfigurationType.validationRules,
  ConfigurationType.approvalProcesses,
  ConfigurationType.workflowRules,
  ConfigurationType.flows,
  ConfigurationType.processBuilderFlows,
  ConfigurationType.apexTriggers,
  ConfigurationType.apexClasses,
  ConfigurationType.cpqData,
  ConfigurationType.fields,
  ConfigurationType.rollups,
  ConfigurationType.recordTypes,
  ConfigurationType.layouts,
];

export const baseWhatDoesItDoTypes = [
  // different endpoint called and different prompt being served for these types
  // changes should be consulted with BE
  ConfigurationType.validationRules,
  ConfigurationType.approvalProcesses,
  ConfigurationType.workflowRules,
  ConfigurationType.flows,
  ConfigurationType.processBuilderFlows,
  ConfigurationType.apexTriggers,
  ConfigurationType.apexClasses,
  ConfigurationType.cpqData,
];

export const EXCLUDED_FROM_WHAT_DOES_IT_DO = [
  ConfigurationType.fields,
  ConfigurationType.objects,
  ...SWEEP_ELEMENTS,
];

export const isWhatDoesItDoAllowed = (type: ConfigurationType) => {
  return !EXCLUDED_FROM_WHAT_DOES_IT_DO.includes(type);
};

export const isAiInputAllowed = (type: ConfigurationType) => {
  return !SWEEP_ELEMENTS.includes(type);
};
